<!-- Filters -->
<div class="row mb-2">
    <div class="col-lg-6 mb-2">
        <input type='text' class="form-control"
               [placeholder]="'ROUTES.TEMPLATES.ADVANCEDTEMPLATES.SEARCH.PLACEHOLDER' | translate"
               [formControl]="searchValueControl"
        />
    </div>
    <div class="col-lg-6 mb-2">
        <ngx-select
                [items]="tags ? (tags | customFieldOptions) : []"
                [formControl]="tagsControl"
                [placeholder]="'ROUTES.ADDRESSBOOK.MYCONTACTS.FILTER.TAGS.PLACEHOLDER' | translate"
                [multiple]="true">
        </ngx-select>
    </div>
</div>